/**
 * Application Service for generating unique sequential Application Numbers
 * Format: Christ-University-27001, Christ-University-27002, Christ-University-27003...
 */

const COUNTER_KEY = 'christ_app_counter';
const INITIAL_COUNTER = 27001;
const LATEST_APP_KEY = 'christ_latest_application';

/**
 * Generates and increments the next unique Application Number
 */
export function generateUniqueAppNumber() {
  let currentCount = parseInt(localStorage.getItem(COUNTER_KEY) || `${INITIAL_COUNTER}`, 10);
  if (isNaN(currentCount) || currentCount < INITIAL_COUNTER) {
    currentCount = INITIAL_COUNTER;
  }
  
  const appNumber = `Christ-University-${currentCount}`;
  
  // Increment counter for next applicant
  localStorage.setItem(COUNTER_KEY, (currentCount + 1).toString());
  
  return appNumber;
}

/**
 * Gets the current counter value without incrementing
 */
export function getCurrentAppCounter() {
  const currentCount = parseInt(localStorage.getItem(COUNTER_KEY) || `${INITIAL_COUNTER}`, 10);
  return isNaN(currentCount) ? INITIAL_COUNTER : currentCount;
}

/**
 * Stores recent application payment data in sessionStorage & localStorage
 */
export function saveApplicationData(appData) {
  try {
    const dataWithTimestamp = {
      ...appData,
      createdAt: new Date().toISOString(),
      formattedDate: new Date().toLocaleString('en-IN', {
        dateStyle: 'full',
        timeStyle: 'medium'
      })
    };
    sessionStorage.setItem(LATEST_APP_KEY, JSON.stringify(dataWithTimestamp));
    localStorage.setItem(`app_${appData.appNumber}`, JSON.stringify(dataWithTimestamp));
    return dataWithTimestamp;
  } catch (err) {
    console.error('Error saving application data:', err);
    return appData;
  }
}

/**
 * Retrieves the latest stored application data
 */
export function getLatestApplicationData() {
  try {
    const data = sessionStorage.getItem(LATEST_APP_KEY);
    if (data) return JSON.parse(data);
  } catch (err) {
    console.error('Error reading application data:', err);
  }
  return null;
}
